import { ComponentConfigType } from '../../utils/data-parser';
import { ComponentType, type IConfig } from '../../types';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_TANSLATE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.FormInput,
  configGroups: [
    {
      title: 'Component Settings',
      items: [
        {
          name: 'placeholder',
          label: 'Placeholder',
          valueComponent: {
            type: 'Input',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
          ],
        },
        {
          name: 'allowClear',
          label: 'Allow Clear',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'size',
          label: 'Size',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Small', value: 'small' },
              { label: 'Middle', value: 'middle' },
              { label: 'Large', value: 'large' },
            ],
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'variant',
          label: 'Variant',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Outlined', value: 'outlined' },
              { label: 'Borderless', value: 'borderless' },
              { label: 'Filled', value: 'filled' },
            ],
            defaultValue: 'outlined',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'status',
          label: 'Status',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Default', value: 'default' },
              { label: 'Error', value: 'error' },
              { label: 'Warning', value: 'warning' },
            ],
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
  ],
};
